export default {
    wig_state_change_operation_complete_invalid_phone_number_warning:
        'הפעולה הושלמה. לא נשלחה הודעה ללקוחה מפני שמספר הטלפון אינו תקין',
}
